module.exports = __webpack_public_path__ + "../resources/img/ic_re_smart_plug_p2.82408ca2.svg";